import script from "./Contact.vue?vue&type=script&setup=true&lang=ts"
export * from "./Contact.vue?vue&type=script&setup=true&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=0ddaee58&lang=scss"

const __exports__ = script;

export default __exports__